import { alpha } from "@mui/material/styles";
import { inputBaseClasses } from "@mui/material/InputBase";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { filledInputClasses } from "@mui/material/FilledInput";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

// ----------------------------------------------------------------------

export default function TextField(theme) {
    const color = {
        focused: theme.palette.text.primary,
        active: theme.palette.text.secondary,
        placeholder: theme.palette.text.disabled
    };

    const font = {
        label: theme.typography.body1,
        value: theme.typography.body1
    };

    return {
        // HELPER
        MuiFormHelperText: {
            defaultProps: {
                component: "div"
            },
            styleOverrides: {
                root: {
                    marginTop: "4px",
                    marginLeft: 0,
                    marginRight: 0,
                    fontsize: "12px",
                    lineHeight: "16px"
                }
            }
        },

        // LABEL
        MuiFormLabel: {
            styleOverrides: {
                root: ({ ownerState }) => ( {
                    ...font.value,
                    color: color.placeholder,
                    [`&.${inputLabelClasses.outlined}`]: {
                        [`&.${inputLabelClasses.sizeSmall}`]: {
                            [`&:not(.${inputLabelClasses.shrink})`]: {
                                transform: "translate(14px, 10px) scale(1)"
                            }
                        },

                        [`&:not(.${inputLabelClasses.sizeSmall})`]: {
                            [`&:not(.${inputLabelClasses.shrink})`]: {
                                transform: "translate(14px, 13px) scale(1)"
                            }
                        }
                    },
                    [`&.${inputLabelClasses.shrink}`]: {
                        ...font.label,
                        fontWeight: 400,
                        color: color.active,
                        [`&.${inputLabelClasses.focused}`]: {
                            color: color.focused
                        },
                        [`&.${inputLabelClasses.error}`]: {
                            color: theme.palette.error.main
                        },
                        [`&.${inputLabelClasses.disabled}`]: {
                            color: theme.palette.text.disabled
                        },
                        [`&.${inputLabelClasses.filled}`]: {
                            transform: "translate(12px, 6px) scale(0.75)"
                        }
                    }
                } )
            }
        },

        // BASE
        MuiInputBase: {
            styleOverrides: {
                root: {
                    [`&.${inputBaseClasses.disabled}`]: {
                        "& svg": {
                            color: theme.palette.text.disabled
                        }
                    }
                },
                input: {
                    ...font.value,
                    "&::placeholder": {
                        opacity: 1,
                        color: color.placeholder
                    }
                }
            }
        },

        // STANDARD
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottomColor: alpha(theme.palette.grey[500], 0.32)
                    },
                    "&:after": {
                        borderBottomColor: color.focused
                    }
                }
            }
        },

        // OUTLINED
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ ownerState }) => ( {
                    // borderRadius: theme.shape.borderRadius,
                    [`&.${outlinedInputClasses.focused}`]: {
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: color.focused
                        }
                    },
                    [`&.${outlinedInputClasses.error}`]: {
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            borderColor: theme.palette.error.main
                        }
                    },
                    [`&.${outlinedInputClasses.disabled}`]: {
                        background: "#F6F6F6",
                        [`& .${outlinedInputClasses.notchedOutline}`]: {
                            // borderColor: theme.palette.action.disabledBackground,
                            borderColor: "rgba(145, 158, 171, 0.2)"
                        }
                    },
                    // [`& .${outlinedInputClasses.input}`]: {
                    //     [`&:not(.${inputBaseClasses.inputSizeSmall})`]: {
                    //         paddingTop: 13.94,
                    //         paddingBottom: 13.94
                    //     },
                    // },
                    // ...(ownerState.size === "medium" && {
                    //     [`& .${outlinedInputClasses.input}`]: {
                    //         paddingTop: 13.94,
                    //         paddingBottom: 13.94
                    //     }
                    // }),
                    // ...(ownerState.size === "medium" && {
                    //     [`& .${outlinedInputClasses.input}.${autocompleteClasses.input}`]: {
                    //         paddingTop: 4.94,
                    //         paddingBottom: 4.94
                    //     }
                    // })

                    ...( ownerState.size === "small" && {
                        [`& .${outlinedInputClasses.input}`]: {
                            paddingTop: 9.94,
                            paddingBottom: 9.94
                        }
                    } )
                } ),
                notchedOutline: {
                    borderColor: alpha(theme.palette.grey[500], 0.2),
                    transition: theme.transitions.create(["border-color"], {
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        },

        // FILLED
        MuiFilledInput: {
            defaultProps: {
                disableUnderline: true
            },
            styleOverrides: {
                root: {
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: alpha(theme.palette.grey[500], 0.08),
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16)
                    },
                    [`&.${filledInputClasses.focused}`]: {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16)
                    },
                    [`&.${filledInputClasses.error}`]: {
                        backgroundColor: alpha(theme.palette.error.main, 0.08),
                        [`&.${filledInputClasses.focused}`]: {
                            backgroundColor: alpha(theme.palette.error.main, 0.16)
                        }
                    },
                    [`&.${filledInputClasses.disabled}`]: {
                        backgroundColor: theme.palette.action.disabledBackground
                    }
                }
            }
        }
    };
}
